import cx from 'classnames';
import PropTypes from 'prop-types';

import { ButtonText } from 'src/components/ButtonText';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { getLanguageLabel } from 'src/data/generation';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  onCtaClick: PropTypes.func.isRequired,
  analyzerToneOfVoice: PropTypes.shape({
    traits: PropTypes.arrayOf(PropTypes.shape({})),
    name: PropTypes.string,
  }),
  brandVoiceExistForLanguage: PropTypes.bool,
  language: PropTypes.string,
};

const defaultProps = {
  className: null,
  analyzerToneOfVoice: null,
  brandVoiceExistForLanguage: false,
  language: null,
};

export const EmptyBanner = ({
  className,
  onCtaClick,
  analyzerToneOfVoice,
  language,
  brandVoiceExistForLanguage,
}) => {
  const styles = useStyles();

  if ((analyzerToneOfVoice?.traits || []).length > 0) {
    return null;
  }

  const { title, cta } = (() => {
    if (brandVoiceExistForLanguage) {
      return {
        title: 'Tone of voice insights are not available',
        cta: 'New tone of voice',
      };
    }

    return {
      title: `Tone of voice insights are not available in ${getLanguageLabel(language)}`,
      cta: 'New brand voice',
    };
  })();

  return (
    <div className={cx(styles.root, className)}>
      <CustomTypography
        className={styles.title}
        variant={TYPOGRAPHY_VARIANT.medium12}
      >
        {title}
      </CustomTypography>
      <CustomTypography
        className={styles.description}
        variant={TYPOGRAPHY_VARIANT.paragraph12}
      >
        Add specific traits to your tone of voice to see if this text is in compliance
      </CustomTypography>
      <ButtonText
        className={styles.buttonCta}
        onClick={() => onCtaClick({ options: { shouldActivateManualStep: true } })}
      >
        {cta}
      </ButtonText>
    </div>
  );
};

EmptyBanner.propTypes = propTypes;
EmptyBanner.defaultProps = defaultProps;
